import { radioAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

var _a = createMultiStyleConfigHelpers(radioAnatomy.keys), definePartsStyle = _a.definePartsStyle, defineMultiStyleConfig = _a.defineMultiStyleConfig;
var baseStyle = definePartsStyle({
    control: {
        border: "1px solid",
        borderColor: "neutrals.700",
        position: "relative",
        _checked: {
            borderColor: "neutrals.800",
            bg: "neutrals.200 !important",
            color: "neutrals.800",
            _hover: {
                borderColor: "neutrals.800",
            },
            _before: {
                content: '""',
                display: "block",
                position: "absolute",
                top: "50%",
                left: "50%",
                width: "50%",
                height: "50%",
                backgroundColor: "currentColor",
                borderRadius: "50%",
                transform: "translate(-50%, -50%)",
            },
        },
        _disabled: {
            borderColor: "neutrals.400",
            bg: "neutrals.white",
            _checked: {
                borderColor: "neutrals.500",
                color: "neutrals.500",
                bg: "neutrals.white !important",
            },
        },
    },
});
var radioTheme = defineMultiStyleConfig({ baseStyle: baseStyle });

export { radioTheme };
//# sourceMappingURL=radio.js.map
